import React, {Component} from 'react'
import moment from 'moment'
import {Button, message} from "antd";
import icon_download from "../img/icon_download.png";
import {
    getAIOFMOpticalSimData,
    getDataDownloadURL,
    getOpticalSarSim
} from '../actions';

export default class MicrowaveListItem extends Component {
    constructor(props) {
        super(props)
        // this.state = {
        //     wsToClientTimerFlag: false
        // }
    }

    componentDidMount() {
        // console.log('微波仿真单条数据条目', this.props.item)
    }

    _downloadMicrowaveData = async (orderid) => {
        const {ordertype} = this.props.item;
        let dataName = ordertype === '微波仿真订单' ? await getOpticalSarSim(orderid) : await getAIOFMOpticalSimData(orderid);
        // let downloadUrls = []
        // console.log('数据明', dataName, typeof dataName);
        if (Array.isArray(dataName) && dataName.length === 0) {
            message.info('当前订单无数据可下载')
        } else {
            dataName.forEach(item => {
                getDataDownloadURL(item.dataname, "微波仿真", this.props.userId).then((data) => {
                    console.log("获取的数据:", data);
                    let downloadUrl = data.data[item.dataname]
                    downloadUrl = downloadUrl.replace("http://10.0.121.14:8084/", "https://caplos.aircas.ac.cn/zdTiles/");
                    let a = 'https://caplos.aircas.ac.cn/zdTiles/'
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = item.dataname; // 设置下载文件的默认名称
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    message.info(`数据${item.dataname}开始下载!`)
                    // downloadUrls.push({downloadUrl:downloadUrl,filename:item.dataname})
                    // 在这里处理返回的数据
                }).catch((error) => {
                    console.error("调用失败:", error);
                    // 处理错误
                });

            })
        }

        // console.log(downloadUrls)
        // downloadUrls.forEach(item=>{
        //
        // })

    }

    render() {
        const {ordercode, createtime, ordermode, orderstatus, orderid} = this.props.item
        // const { expendId, setExpend } = this.props
        return (
            <div className='order-produce-list-item'>
                <div className='order-produce-list-item-unit'>
                    <span className='order-produce-list-item-title'>{ordercode}</span>
                    <Button size='small' className='download-order-list-item-button' type="primary"
                        // disabled={!this.state.downloadVisible}
                            icon={<img src={icon_download} alt=""></img>}
                            onClick={() => this._downloadMicrowaveData(orderid)}>下载</Button>
                </div>
                <div className='order-produce-list-item-split'/>
                <div className='order-produce-list-item-unit'>
                    <div>
                        <span className='order-produce-list-item-text1'>订单模式:{ordermode}</span>
                        <span className='order-produce-list-item-text1'>订单状态:{orderstatus}</span>
                    </div>
                    <span
                        className='order-produce-list-item-text2'>下单时间：{moment(createtime).format("yyyy-MM-DD HH:mm:ss")}</span>
                </div>
            </div>
        )
    }
}
const mapState = state => ({
    user: state.userReducer.get('user').toJS(),
})